module.exports = __webpack_public_path__ + "img/scenes_8.33a48211.png";